module.exports = __webpack_public_path__ + "img/shui.886cceba.svg";